export default "__VITE_ASSET__Bn3BRxN9__"